var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTg = function SvgTg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0m133.059 161.936L343.591 379a16.007 16.007 0 0 1-25.177 9.593l-66.136-48.861-40.068 37.8a5.43 5.43 0 0 1-7.74-.294l-.861-.946 6.962-67.375 125.484-114.651a3.358 3.358 0 0 0-4.061-5.317l-160.479 101.57-69.115-23.212a9.393 9.393 0 0 1-.32-17.694L372.5 147.744a12.441 12.441 0 0 1 16.559 14.192"
  })));
};
export default SvgTg;